'use client';
import Image from 'next/image';

import Logo from '@assets/images/60.yilSetur.png';
import RouterLink from '@components/ui/RouterLink';

import {
  SimpleHeaderWrapper,
  SimpleHeaderLogo,
  SimpleHeaderContentWrapper,
} from './SimpleStyle';

interface HeaderSimpleProps {
  align?: 'flex-start' | 'center' | 'flex-end';
  hideBoxShadow?: boolean;
}

const Simple = ({ align, hideBoxShadow = false }: HeaderSimpleProps) => {
  return (
    <SimpleHeaderWrapper hideBoxShadow={hideBoxShadow}>
      <SimpleHeaderContentWrapper align={align}>
        <RouterLink href='/'>
          <SimpleHeaderLogo>
            <Image src={Logo} width={180} height={30} alt='Setur Logo' />
          </SimpleHeaderLogo>
        </RouterLink>
      </SimpleHeaderContentWrapper>
    </SimpleHeaderWrapper>
  );
};

export default Simple;
